export default __webpack_public_path__ + "static/media/employeeDirectory.01afd322.png";